import { version } from '../../../../package.json';

export const environment = {
  authen: {
    appKey: 'MOBILE_HUTECH', // <-- ID from backend
    apiAuth: 'http://api.lamgigio.net/core-phan-quyen/api-authentication-v2/api/auth',
    googleAuthClientID: '662939237880-iocgm8bu3a97cvfdq77ekbb1dvo4qfd8.apps.googleusercontent.com',
    facebookAuthSecretKey: 'cb59f8f5a689cb98c44289d1136b0c75',
    reCapchaSecretKey: '6LcRH0EUAAAAADIgNOVAUuaYVRNi6HfExT3sdr2F',
    useMockData: false,
    autoLoginByMockUser: false,
    supportLink: {
      forgotPassword:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
      createNewAccount: '',
      verifyAtLogin:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
      canNotLogin:
        'https://docs.google.com/document/d/1py_zndTVOcK5Ij1yfVtIaquvZa_aiAU9/pub',
    },
    accountTypes: [
      {
        id: 'MOBILE_HUTECH',
        key: 'MOBILE_HUTECH', // APP KEY
        displayText: 'auth.component.login.form.can_bo_nhan_vien_AccounType',
        enableLanguage: true,
        show: true,
        default: false,
      },
      {
        id: 'SINHVIEN_DAIHOC',
        key: 'SINHVIEN_DAIHOC',
        displayText: 'auth.component.login.form.SV_DHCD_AccounType',
        enableLanguage: true,
        show: true,
        default: false,
      },
      {
        id: 'SINHVIEN_CYU',
        key: 'SINHVIEN_CYU',
        displayText: 'auth.component.login.form.SV_CYU_AccounType',
        enableLanguage: true,
        show: true,
        default: false,
      },
      {
        id: 'HOC_VIEN',
        key: 'HOC_VIEN',
        displayText: 'auth.component.login.form.HOC_VIEN_AccounType',
        enableLanguage: true,
        show: true,
        default: false,
      }
    ],
    customLoginPageURL: 'https://sso.ttithutech.com/welcome'
  },
  //tu dong login
  domain: {
    apiAuth: 'https://sso.api.ttithutech.com/api',
    main: 'https://sso.api.ttithutech.com/api',
    apiSupportEmail: '',
    urlWebLogIn: '',
    urlWebOld: 'http://permission-v1.ttithutech.com/#',
    urlWebEduzaa: 'https://eduzaa.member.lamgigio.net',

  },

  /**
   *  @deprecated by authen mock variable AuthenUserMock
   */
  path: {
    external_link: {
      webDaoTao: 'https://daotao.hutech.edu.vn',
    },
  },
  developer: {
    username: "NNV0050588",
    password: "123qwe@..",
  },

  /**
   *  @deprecated by application.storage
   */
  storage: {
    cookies: {
      expireInSeconds: 3600, // 1 hour
    },
  },

  application: {
    http: {
      timeout: 30 * 1000, // 30 giây
    },
    responseBodyVersion: '1.0.0', // Phiên bản của định dạng dữ liệu trả về từ API
    /**
     * @deprecated by authen group
     * need change metadata.app to authen.appKey
     */
    metadata: {
      capcha: null, //TODO-HTUECH: key này để làm gì? quy tắt setting ntn
      app: 'MOBILE_HUTECH', //TODO-HTUECH: app key?
      diuu: '123',
      key_option_xac_thuc: 'erp1', //TODO-HTUECH: key này để làm gì? quy tắt setting ntn
    },

    /**
     * @deprecated by config/ui.const.ts variable
     * Do not use this valiable for newer module GLOBAL_CONFIG_PAGE_SIZE
     */
    ui: {
      pagingation: {
        pageSizeDefault: 10, // Số mục trên mỗi trang
        pageSizeOptions: [10, 20, 50, 100, 200], // Tùy chọn kích thước trang,
      },
    },
    storage: {
      cookies: {
        expireInSeconds: 3600, // 1 hour
      },
    },

    package_version: version,
    baseHref: '/',
  },
  production: true,
  client_sso: {
    "MOBILE_HUTECH": {
      app_key: "MOBILE_HUTECH",
      redirect_uri: "https://sso.ttithutech.com/"
    },
    "EDURA": {
      app_key: "MOBILE_HUTECH",
      redirect_uri: "https://edura-admin.ttithutech.com"
    }
  }
};
